import { useNavigate } from 'react-router';

import { useAuthService, useHasPermissions } from '~platform/auth';

import { ROUTES } from '~shared/config/routes';
import { ResponsiveMenu } from '~shared/ui/responsive-menu';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Icon } from '@breezeventures/ui-kit/next/icon';

export const ProfileMenu = () => {
  const { logout } = useAuthService();
  const navigate = useNavigate();
  const { checkPermissions } = useHasPermissions();
  const canViewProfile = checkPermissions(['PROFILE_VIEW']);

  const items = [
    ...(canViewProfile
      ? [
          {
            key: 'profile',
            label: 'Profile',
            icon: <Icon name="user" size={24} version="v1" />,
            onClick: () => navigate(ROUTES.profile),
          },
        ]
      : []),
    {
      key: 'logout',
      label: 'Logout',
      icon: (
        <Icon
          name="bracket-right-arrow-left"
          size={24}
          version="v1"
          className="size-5"
        />
      ),
      onClick: logout,
    },
  ];

  return (
    <ResponsiveMenu
      trigger={
        <IconButton variant="secondary" size="s" aria-label="Account menu">
          <Icon name="user" size={24} version="v1" />
        </IconButton>
      }
      items={items}
    />
  );
};
